import { render } from "./CategorySubcategories.vue?vue&type=template&id=7e6d822e"
import script from "./CategorySubcategories.vue?vue&type=script&lang=js"
export * from "./CategorySubcategories.vue?vue&type=script&lang=js"

import exportComponent from "/usr/local/var/www/duo_front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__